import { getAllDataWithoutToast } from "apis/customApiHandler";
import useDebounce from "hooks/useDebounce";
import React, { useEffect, useRef, useState } from "react";
import { QueryClient, useQuery, useQueryClient } from "react-query";
import { convertToIndianTimezone, formatDate } from "utils/helpers";


const RenderProgressBar = ({ progressState, setProgressState, event, syncEvent }) => {
    console.log("Percent", progressState?.percent)
    const [loading, setLoading] = useState(false);
    const [forceRender, setForceRender] = useState(0);
    const debouncedValue = useDebounce(forceRender, 2000);
    const queryClient = useQueryClient()
    const queryKey = [event.code, debouncedValue && debouncedValue];
    const progressRef = useRef(progressState?.percent)


    useEffect(() => {
        const interval = setInterval(() => {
            setForceRender((prev) => prev + 1); // Increment to trigger re-render
        }, 2000);

        return () => clearInterval(interval); // Cleanup on unmount
    }, []);

    const { data } = useQuery(
        queryKey,
        () => 
            // if (progressState?.percent === 100) {
            //     queryClient.invalidateQueries([event.code, debouncedValue && debouncedValue])
            //     setProgressState(prevState => ({
            //         ...prevState,
            //         [event.code]: {
            //         }
            //     }));
            // }
            getAllDataWithoutToast('/syncLog', {
                eventCode: event.code,
                limit: 3,
                page: 1,
            })
        // }
    );

    console.log("loading", loading, progressState)

    useEffect(() => {
        console.log(progressRef.current)
        if ((!progressRef.current && (!progressState?.percent || progressRef.percent === 100))) {
            progressRef.current = 1;
            console.log("Invalidating Query")
            queryClient.invalidateQueries(queryKey)
            setProgressState(prevState => ({
                ...prevState,
                [event.code]: {
                    percent: 0
                }
            }));
        }
    }, [loading, progressState?.percent])

    return <div className="border flex flex-col items-start gap-4 w-full p-4 lg:max-w-[70vw] border-gray-300 rounded-lg bg-white">
        <div className=" flex flex-row w-full gap-4 w-full text-center ">
            {/* Button Section */}
            <button
                disabled={progressState?.percent != 100 && (loading || (progressState?.percent))}
                onClick={async () => {
                    setLoading(true);
                    await syncEvent(event.api, event?.code, setLoading);
                    setForceRender(prev => prev + 1)
                }}
                className="px-4 py-2 text-sm font-medium bg-green-500 w-48 hover:bg-green-700 text-white rounded-md transition disabled:bg-gray-400"
            >
                {event?.name} {" "}
                {progressState?.percent != 100 && (loading || (progressState?.percent)) ? '⏳' : ''}
            </button>

            {/* Progress Bar Section */}

            {progressState?.percent ? <div className="flex-1">
                <div className="relative w-full bg-gray-200 rounded-full h-3 overflow-hidden">
                    <div
                        className="h-full bg-green-600 transition-all duration-300"
                        style={{ width: `${progressState?.percent ?? 0}%` }}
                    ></div>
                </div>
                <p className="text-sm text-gray-600 mt-1">
                    {parseFloat(progressState?.percent ?? 0).toFixed(2)}% completed
                </p>
            </div> : <></>}


        </div>
        {data?.data?.length ? <p className="font-semibold text-sm poppins px-1"> Action History: </p> : <></>}
        <ul className="flex flex-col items-start self-start text-gray-700 text-sm rounded-md">
            {data?.data?.map(item => <li className="flex flex-row gap-x-2 rounded-md m-[1px] p-1 w-full border-b-1">
                <div>
                    <span className={`${item.status === "pending" ? "bg-gray-200 text-gray-500" : item.status === "failed" ? "bg-red-200 text-red-500" : "bg-green-100 text-green-600"} font-semibold px-2 py-1 rounded-md w-24 bg-gray-200`}>
                        {item.status} {" "}
                        {item.status === "pending" ? '⏳' : item.status === "failed" ? '❌' : '✅'}
                        </span>
                </div>
                <div className="">
                    <b>Synced At: </b> {convertToIndianTimezone(item.createdAt)},
                </div>
                <div className="">
                    <b>By: </b> {item.initiatedBy?.name ?? "System Generated"},
                </div>

            </li>)}
        </ul>
    </div>
}

export default RenderProgressBar